module.exports = __webpack_public_path__ + "img/icon-4.9ff37cfc.png";